import * as React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

export default class DexteritySvg extends React.PureComponent<BaseSvgProps> {
  static defaultProps = {
    className: "",
  };

  render() {
    const { className, fillColor, secondaryFillColor } = this.props;

    return (
      <BaseSvg viewBox="0 0 36.17 35.63" className={className}>
        <path
          fill={secondaryFillColor}
          d="M13,20s1-5.61,7.7-7c0,0-2.52,1.32-2.6,1.9s1.43,2-.36,3.8C15.62,20.79,14,17.16,13,20Z"
        />
        <path
          fill={secondaryFillColor}
          d="M15.68,30.39c.06,0,.55.05,1.28.07L15.71,30Z"
        />
        <path
          fill={fillColor}
          d="M10.45,6.26A7.07,7.07,0,0,0,6,2.16L7.06,7.39Z"
        />
        <path
          fill="none"
          stroke={fillColor}
          strokeMiterlimit={10}
          strokeWidth="0.65px"
          d="M9.49,26.36a15.46,15.46,0,0,1-1.48,9"
        />
        <path
          fill="none"
          stroke={fillColor}
          strokeMiterlimit={10}
          strokeWidth="0.55px"
          d="M11.67,27.58S14,30.79,13,34.15"
        />
        <path
          fill="none"
          stroke={fillColor}
          strokeMiterlimit={10}
          strokeWidth="0.55px"
          d="M5.32,28.82a6.15,6.15,0,0,1-1.45,5.33"
        />
        <path
          fill="none"
          d="M10.06,18.91a6,6,0,0,1-3.69,1.7A1.73,1.73,0,0,1,5,20.09c-.9-1-.12-3.19,1.76-4.86a6,6,0,0,1,3.69-1.7,1.73,1.73,0,0,1,1.34.52C12.72,15.06,11.94,17.24,10.06,18.91Z"
        />
        <path
          fill="none"
          d="M10.48,14.48a5.24,5.24,0,0,0-3.06,1.46C5.8,17.38,5.34,19,5.74,19.46a.87.87,0,0,0,.63.2A5.24,5.24,0,0,0,9.43,18.2a6,6,0,0,0,1.66-2.29,1.35,1.35,0,0,0,0-1.23A.87.87,0,0,0,10.48,14.48Z"
        />
        <path
          fill={fillColor}
          d="M21.39,23.19h.12l.54,0h.2l.43,0,.17,0,.52-.06h.07l.37-.06.12,0,.2,0h.07l.08,0a4.69,4.69,0,0,0-1.47-1.67A9.68,9.68,0,0,1,24,21l.42,0c.3,0,.6-.06.93-.06s.57,0,.86,0l.45,0a14.14,14.14,0,0,1,1.48.22c-.06-.27-.13-.6-.21-1l-.14-.58-.13-.55c-.07-.3-.15-.6-.24-.93l-.07-.27a44.12,44.12,0,0,0-1.88-5.52l0-.09c-.21-.48-.42-1-.65-1.43h0a21.2,21.2,0,0,0-1.76-3H21.74A16.87,16.87,0,0,0,12.81,0V7.39s-9.14,3.49-9.34,6.16-.41,6.26-1,6.88-3,3.75-2.34,4.36,4.6,5.08,6.76,5.08,7.19-.51,8.42,0l.44.16L15.83,29s.51,0,1.25.05h.14c.33,0,.72,0,1.13,0l.32,0,1-.11.48-.07c.35-.06.71-.13,1.07-.21l.49-.11A13,13,0,0,0,23.33,28a12.19,12.19,0,0,1-3.67-2.79l.6.07.18,0,.39,0h1.6a5.59,5.59,0,0,1-2.34-2.23,6.62,6.62,0,0,0,1.28.11Z"
        />
        <path
          fill={secondaryFillColor}
          d="M10.15,16.32A3.88,3.88,0,0,1,9.07,17.8a3.38,3.38,0,0,1-2,.94.56.56,0,0,1-.41-.13c-.26-.29,0-1.35,1.08-2.27a3.38,3.38,0,0,1,2-.94.56.56,0,0,1,.41.13A.87.87,0,0,1,10.15,16.32Z"
        />
        <path
          fill={fillColor}
          d="M35.1,21.8c0-.13,0-.25,0-.39a8.32,8.32,0,0,0-1.85-4.57,7.41,7.41,0,0,1,2.07,1.36c-1.38-3.91-4.48-4-4.8-4a25.72,25.72,0,0,0-3.73-2.4,49.22,49.22,0,0,1,2.93,9.45l.29,1.4-1.4-.28a12.45,12.45,0,0,0-2.45-.26l-.72,0a4.55,4.55,0,0,1,.37.63l.53,1.1-1.2.24a18.83,18.83,0,0,1-2.24.28,2.09,2.09,0,0,0,.53.31l4.25,1.58-4.53.25H23a8.52,8.52,0,0,0,1.41.83l2,.91-2,.83a17.27,17.27,0,0,1-6.11,1.14c2,2.75,8.06,5.4,8.06,5.4-.46-2.55,2.55-4.51,2.55-4.51.89.27,1,4.51,1,4.51a19.44,19.44,0,0,0,4.61-7.81A7.25,7.25,0,0,1,36,30.17C36.53,28.15,35.8,24.49,35.1,21.8Z"
        />
        <path
          fill={secondaryFillColor}
          d="M6.12,19.45a6.75,6.75,0,0,1,5.53-5s-1.81.95-1.87,1.36,1,1.45-.26,2.73C8,20,6.77,17.44,6.12,19.45Z"
        />
      </BaseSvg>
    );
  }
}
